
export const GRID_SIZE = 20;
export const SHAPE_SIZE = 60;
export const SVG_CANVAS_ID = 'genogram-canvas';

export const CANVAS_WIDTH = 4000;
export const CANVAS_HEIGHT = 3000;

export const LINE_THICKNESS = {
  thin: 1.5,
  medium: 2.5,
  large: 4,
};

export const LINE_STYLES = {
  solid_thin: { thickness: 1.5, dashed: false, label: '細' },
  solid_medium: { thickness: 2.5, dashed: false, label: '中' },
  solid_large: { thickness: 4, dashed: false, label: '太' },
  dashed: { thickness: 2.5, dashed: true, label: '点線' },
};

export const FONT_SIZES = {
    small: 12,
    medium: 16,
    large: 20,
};